<script setup lang="ts">
import { useGameStore } from '@/stores/gameStore'
import ModalBuilding from '@/components/Interface/Modal/Modals/ModalBuilding.vue'
import ModalBuildShip from '@/components/Interface/Modal/Modals/ModalBuildShip.vue'
import ModalMapSelectPlayerShips from '@/components/Interface/Modal/Modals/ModalMapSelectPlayerShips.vue'
import ModalEditShipName from '@/components/Interface/Modal/Modals/ModalEditShipName.vue'
import ModalEditShipDesignName from '@/components/Interface/Modal/Modals/ModalEditShipDesignName.vue'
import ModalMapAttack from '@/components/Interface/Modal/Modals/ModalMapAttack.vue'
import ModalRequestAudience from '@/components/Interface/Modal/Modals/ModalRequestAudience.vue'
import ModalTech from '@/components/Interface/Modal/Modals/ModalTech.vue'
import ModalAllianceTech from '@/components/Interface/Modal/Modals/ModalAllianceTech.vue'
import ModalAssignToFleet from '@/components/Interface/Modal/Modals/ModalAssignToFleet.vue'
import ModalCreateFleet from '@/components/Interface/Modal/Modals/ModalCreateFleet.vue'
import ModalEditFleetName from '@/components/Interface/Modal/Modals/ModalEditFleetName.vue'
import ModalPlanetsSetProductionQueue from '@/components/Interface/Modal/Modals/ModalPlanetsSetProductionQueue.vue'
import ModalPlanetsSetPopulationAssignments from '@/components/Interface/Modal/Modals/ModalPlanetsSetPopulationAssignments.vue'
import ModalMapFollow from '@/components/Interface/Modal/Modals/ModalMapFollow.vue'
import ModalMapFollowAttack from '@/components/Interface/Modal/Modals/ModalMapFollowAttack.vue'
import ModalCreateShipGroup from '@/components/Interface/Modal/Modals/ModalCreateShipGroup.vue'
import ModalMinistryCandidate from '@/components/Interface/Modal/Modals/ModalMinistryCandidate.vue'
import ModalMapSelectPlayerFleetShips from '@/components/Interface/Modal/Modals/ModalMapSelectPlayerFleetShips.vue'
import ModalConfirmationDelete from '@/components/Interface/Modal/Modals/ModalConfirmationDelete.vue'
import ModalBuildBuilding from '@/components/Interface/Modal/Modals/ModalBuildBuilding.vue'
import ModalCreatePlanetGroup from '@/components/Interface/Modal/Modals/ModalCreatePlanetGroup.vue'
import ModalAttachToShipGroup from '@/components/Interface/Modal/Modals/ModalAttachToShipGroup.vue'
import ModalAttachToPlanetGroup from '@/components/Interface/Modal/Modals/ModalAttachToPlanetGroup.vue'
import ModalOreRefinery from '@/components/Interface/Modal/Modals/ModalOreRefinery.vue'
import ModalOreDetails from '@/components/Interface/Modal/Modals/ModalOreDetails.vue'
import ModalCreatePQA from '@/components/Interface/Modal/Modals/ModalCreatePQA.vue'
import ModalConfigPQA from '@/components/Interface/Modal/Modals/ModalConfigPQA.vue'
import ModalRenamePQA from '@/components/Interface/Modal/Modals/ModalRenamePQA.vue'
import ModalEditPlanetName from '@/components/Interface/Modal/Modals/ModalEditPlanetName.vue'
import ModalCreateShipDesign from '@/components/Interface/Modal/Modals/ModalCreateShipDesign.vue'
import ModalCreateShipDesignSave from '@/components/Interface/Modal/Modals/ModalCreateShipDesignSave.vue'
import ModalOreTrade from '@/components/Interface/Modal/Modals/ModalOreTrade.vue'
import ModalOreTradeConfig from '@/components/Interface/Modal/Modals/ModalOreTradeConfig.vue'
import ModalBattleReport from '@/components/Interface/Modal/Modals/ModalBattleReport.vue'
import ModalPlanetsSetTax from '@/components/Interface/Modal/Modals/ModalPlanetsSetTax.vue'
import ModalDayWeek from '@/components/Interface/Modal/Modals/ModalDayWeek.vue'
import ModalSpy from '@/components/Interface/Modal/Modals/ModalSpy.vue'
import ModalSpyMissionSelectPlayer from '@/components/Interface/Modal/Modals/ModalSpy/Modals/ModalSpyMissionSelectPlayer.vue'
import ModalStartCountDown from '@/components/Interface/Modal/Modals/ModalStartCountDown.vue'
import ModalNewChat from '@/components/Interface/Modal/Modals/ModalNewChat.vue'
import ModalMapSettings from '@/components/Interface/Modal/Modals/ModalMapSettings.vue'
import ModalNewsSettings from '@/components/Interface/Modal/Modals/ModalNewsSettings.vue'
import ModalTechLegend from '@/components/Interface/Modal/Modals/ModalTechLegend.vue'
import ModalTechQueue from '@/components/Interface/Modal/Modals/ModalTechQueue.vue'
import ModalCreateAlliance from '@/components/Interface/Modal/Modals/ModalCreateAlliance.vue'
import ModalEditAllianceDescription from '@/components/Interface/Modal/Modals/ModalEditAllianceDescription.vue'
import ModalEditAllianceImage from '@/components/Interface/Modal/Modals/ModalEditAllianceImage.vue'
import ModalViewAlliance from '@/components/Interface/Modal/Modals/ModalViewAlliance.vue'
import ModalAllianceSciencePercentage from '@/components/Interface/Modal/Modals/ModalAllianceSciencePercentage.vue'
import ModalRepairAction from '@/components/Interface/Modal/Modals/ModalRepairAction.vue'
import ModalWaitAction from '@/components/Interface/Modal/Modals/ModalWaitAction.vue'
import ModalWebGLError from '@/components/Interface/Modal/Modals/ModalWebGLError.vue'
import ModalResourceTerraforming from '@/components/Interface/Modal/Modals/ModalResourceTerraforming.vue'
import ModalRingworldConversion from '@/components/Interface/Modal/Modals/ModalRingworldConversion.vue'
import ModalHoursOnline from '@/components/Interface/Modal/Modals/ModalHoursOnline.vue'
import ModalBattleSimulatorAddDesign from '@/components/Interface/Modal/Modals/ModalBattleSimulatorAddDesign.vue'
import ModalBattleSimulatorCopyFleet from '@/components/Interface/Modal/Modals/ModalBattleSimulatorCopyFleet.vue'
import ModalBattleSimulatorResult from '@/components/Interface/Modal/Modals/ModalBattleSimulatorResult.vue'
import ModalPlanetAdvancedSelect from '@/components/Interface/Modal/Modals/ModalPlanetAdvancedSelect.vue'

const gameStore = useGameStore()
</script>

<template>
  <!-- Level 1 Modals -->
  <div v-if="gameStore.modalType === 'building'">
    <ModalBuilding />
  </div>
  <div v-if="gameStore.modalType === 'dayWeek'">
    <ModalDayWeek />
  </div>

  <div v-else-if="gameStore.modalType === 'editPlanetName'">
    <ModalEditPlanetName />
  </div>
  <div v-else-if="gameStore.modalType === 'createShipDesign'">
    <ModalCreateShipDesign />
  </div>
  <div v-else-if="gameStore.modalType === 'createShipDesignSave'">
    <ModalCreateShipDesignSave />
  </div>
  <div v-else-if="gameStore.modalType === 'planetBuildShip'">
    <ModalBuildShip />
  </div>
  <div v-else-if="gameStore.modalType === 'planetBuildBuilding'">
    <ModalBuildBuilding />
  </div>
  <div v-else-if="gameStore.modalType === 'mapSelectPlayerShip'">
    <ModalMapSelectPlayerShips />
  </div>
  <div v-else-if="gameStore.modalType === 'mapSelectPlayerFleetShips'">
    <ModalMapSelectPlayerFleetShips />
  </div>
  <div v-else-if="gameStore.modalType === 'editShipName'">
    <ModalEditShipName />
  </div>
  <div v-else-if="gameStore.modalType === 'editShipDesignName'">
    <ModalEditShipDesignName />
  </div>
  <div v-else-if="gameStore.modalType === 'mapAttack'">
    <ModalMapAttack />
  </div>
  <div v-else-if="gameStore.modalType === 'mapFollow'">
    <ModalMapFollow />
  </div>
  <div v-else-if="gameStore.modalType === 'mapFollowAttack'">
    <ModalMapFollowAttack />
  </div>
  <div v-else-if="gameStore.modalType === 'battleReport'">
    <ModalBattleReport />
  </div>
  <div v-else-if="gameStore.modalType === 'requestAudience'">
    <ModalRequestAudience />
  </div>
  <div v-else-if="gameStore.modalType === 'tech'">
    <ModalTech />
  </div>
  <div v-else-if="gameStore.modalType === 'allianceTech'">
    <ModalAllianceTech />
  </div>
  <div v-else-if="gameStore.modalType === 'techLegend'">
    <ModalTechLegend />
  </div>
  <div v-else-if="gameStore.modalType === 'techQueue'">
    <ModalTechQueue />
  </div>
  <div v-else-if="gameStore.modalType === 'createPQA'">
    <ModalCreatePQA />
  </div>
  <div v-else-if="gameStore.modalType === 'configPQA'">
    <ModalConfigPQA />
  </div>
  <div v-else-if="gameStore.modalType === 'renamePQA'">
    <ModalRenamePQA />
  </div>
  <div v-else-if="gameStore.modalType === 'assignToFleet'">
    <ModalAssignToFleet />
  </div>
  <div v-else-if="gameStore.modalType === 'createFleet'">
    <ModalCreateFleet />
  </div>
  <div v-else-if="gameStore.modalType === 'editFleetName'">
    <ModalEditFleetName />
  </div>
  <div v-else-if="gameStore.modalType === 'planetsSetProductionQueue'">
    <ModalPlanetsSetProductionQueue />
  </div>
  <div v-else-if="gameStore.modalType === 'planetsSetPopulationAssignments'">
    <ModalPlanetsSetPopulationAssignments />
  </div>
  <div v-else-if="gameStore.modalType === 'planetsSetTax'">
    <ModalPlanetsSetTax />
  </div>
  <div v-else-if="gameStore.modalType === 'createShipGroup'">
    <ModalCreateShipGroup />
  </div>
  <div v-else-if="gameStore.modalType === 'createPlanetGroup'">
    <ModalCreatePlanetGroup />
  </div>
  <div v-else-if="gameStore.modalType === 'createAlliance'">
    <ModalCreateAlliance />
  </div>
  <div v-else-if="gameStore.modalType === 'editAllianceDescription'">
    <ModalEditAllianceDescription />
  </div>
  <div v-else-if="gameStore.modalType === 'editAllianceImage'">
    <ModalEditAllianceImage />
  </div>
  <div v-else-if="gameStore.modalType === 'viewAlliance'">
    <ModalViewAlliance />
  </div>
  <div v-else-if="gameStore.modalType === 'allianceSettings'">
    <ModalAllianceSciencePercentage />
  </div>
  <div v-else-if="gameStore.modalType === 'repairAction'">
    <ModalRepairAction />
  </div>
  <div v-else-if="gameStore.modalType === 'waitAction'">
    <ModalWaitAction />
  </div>
  <div v-else-if="gameStore.modalType === 'attachToShipGroup'">
    <ModalAttachToShipGroup />
  </div>
  <div v-else-if="gameStore.modalType === 'attachToPlanetGroup'">
    <ModalAttachToPlanetGroup />
  </div>
  <div v-else-if="gameStore.modalType === 'ministryCandidate'">
    <ModalMinistryCandidate />
  </div>
  <div v-else-if="gameStore.modalType === 'spy'">
    <ModalSpy />
  </div>
  <div v-else-if="gameStore.modalType === 'startCountDown'">
    <ModalStartCountDown />
  </div>
  <!-- Ore Modals -->
  <div v-if="gameStore.modalType === 'oreTrade'">
    <ModalOreTrade />
  </div>
  <div v-if="gameStore.modalType === 'oreRefinery'">
    <ModalOreRefinery />
  </div>
  <div v-if="gameStore.modalType === 'oreDetails'">
    <ModalOreDetails />
  </div>
  <div v-if="gameStore.modalType === 'resourceTerraforming'">
    <ModalResourceTerraforming />
  </div>
  <div v-if="gameStore.modalType === 'ringworldConversion'">
    <ModalRingworldConversion />
  </div>
  <!-- Chat Modals -->
  <div v-if="gameStore.modalType === 'newChat'">
    <ModalNewChat />
  </div>
  <!-- Level 2 Modals -->
  <div v-if="gameStore.modal2Type === 'confirmationDelete'">
    <ModalConfirmationDelete />
  </div>
  <div v-if="gameStore.modal2Type === 'oreTradeConfig'">
    <ModalOreTradeConfig />
  </div>
  <div v-if="gameStore.modal2Type === 'spyMissionSelectPlayer'">
    <ModalSpyMissionSelectPlayer />
  </div>
  <div v-if="gameStore.modalType === 'mapSettings'">
    <ModalMapSettings />
  </div>
  <div v-if="gameStore.modalType === 'newsSettings'">
    <ModalNewsSettings />
  </div>
  <div v-if="gameStore.modalType === 'error'">
    <ModalWebGLError />
  </div>
  <div v-if="gameStore.modalType === 'hoursOnline'">
    <ModalHoursOnline />
  </div>
  <div v-if="gameStore.modalType === 'battleSimulatorAddAttackingDesign' || gameStore.modalType === 'battleSimulatorAddDefendingDesign'">
    <ModalBattleSimulatorAddDesign />
  </div>
  <div v-if="gameStore.modalType === 'battleSimulatorCopyAttackingFleet' || gameStore.modalType === 'battleSimulatorCopyDefendingFleet'">
    <ModalBattleSimulatorCopyFleet />
  </div>
  <div v-if="gameStore.modalType === 'battleSimulatorResult'">
    <ModalBattleSimulatorResult />
  </div>
  <div v-if="gameStore.modalType === 'planetAdvancedSelect'">
    <ModalPlanetAdvancedSelect />
  </div>
</template>

<style scoped lang="scss"></style>
